"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FunctionalTab = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/FunctionalTab.style"));
var _TabsContext = require("../../contexts/TabsContext");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var FunctionalTab = /*#__PURE__*/function (_PureComponent) {
  _inherits(FunctionalTab, _PureComponent);
  var _super = _createSuper(FunctionalTab);
  function FunctionalTab() {
    var _this;
    _classCallCheck(this, FunctionalTab);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.handleClick = function () {
      _this.context.setSelectedTabId(_this.props.tabId);
    };
    _this.handleKeyPress = function (event) {
      _this.context.setNextTab(event);
    };
    return _this;
  }
  _createClass(FunctionalTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.registerTab(this.props.tabId);
    }
  }, {
    key: "setFocus",
    value:
    /**
     * Uses ref to set the focus when needed.
     */
    function setFocus() {
      if (!this.context.needFocus || !this.ref.current) return;
      this.ref.current.focus();
    }
    /**
     * Returns the string to be used inside the invisible span for screen readers.
     */
  }, {
    key: "getScreenReaderSpanContent",
    value: function getScreenReaderSpanContent() {
      return this.props.t('Iteration', {
        iterator: "".concat(this.props.screenReaderText ? "".concat(this.props.screenReaderText, ", ") : '', "tab ").concat(this.context.tabHash[this.props.tabId] + 1),
        array: this.context.tabsNumberTotal
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isActiveTab = this.context.selectedTabId && this.context.selectedTabId === this.props.tabId;
      if (isActiveTab) this.setFocus();
      return /*#__PURE__*/_react["default"].createElement(Styled.ClickableTab, {
        "aria-selected": !!isActiveTab,
        "aria-controls": "".concat(this.props.tabId, "-tab"),
        ref: this.ref,
        role: "tab",
        id: this.props.tabId,
        tabIndex: isActiveTab ? 0 : -1,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyPress,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix)
      }, /*#__PURE__*/_react["default"].createElement(Styled.InvisibleSpan, null, this.getScreenReaderSpanContent()), /*#__PURE__*/_react["default"].cloneElement(this.props.children, {
        isActiveTab: isActiveTab
      }));
    }
  }]);
  return FunctionalTab;
}(_react.PureComponent);
exports.FunctionalTab = FunctionalTab;
FunctionalTab.contextType = _TabsContext.TabsContext;
FunctionalTab.displayName = "FunctionalTab";
var _default = (0, _reactI18next.withTranslation)()(FunctionalTab);
exports["default"] = _default;